import { createContext } from 'react';
import SocketState from './state';

const SocketContext = createContext<SocketState>(new SocketState());

export default SocketContext;
